// Styles for SkeletonLoaderV2 go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { SkeletonLoaderDuration } from '../../modules';

export const StyledSkeletonLoaderV2 = styled.div`
  background-color: ${baseVariables.color['neutral40']};
  color: ${baseVariables.color['base20']};
  -webkit-animation: fadein ${SkeletonLoaderDuration} ease-in alternate infinite;
  -moz-animation: fadein ${SkeletonLoaderDuration} ease-in alternate infinite;
  animation: fadein ${SkeletonLoaderDuration} ease-in alternate infinite;
  border-radius: ${toRem(8)};
  @-webkit-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @-moz-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
`;
